import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import type { SolutionId } from '../../types/platform';
import { SOLUTIONS, solutionPath } from '../../data/solutions';
import { trackEvent } from '../../utils/analytics';
import { SectionHeading } from '../ui/SectionHeading';

/** Links to the other five solution pages. */
export function OtherSolutions({
  current
}: {
  current: SolutionId;
}) {
  return <section aria-labelledby="other-solutions-heading" className="border-b border-hairline-soft bg-ink" data-id="element-954" data-mp="dgdmfqsdaq8z">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-16 sm:px-6 lg:px-8 lg:py-20" data-id="element-955" data-mp="i9zsv17xtxwc">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-956" data-mp="3lbxauy3do6e">
          <SectionHeading eyebrow="Same agents" headingId="other-solutions-heading" title="Other due diligence workflows." data-id="element-957" data-mp="8jdipmizpzl1" />
          <Link to="/solutions" className="inline-flex min-h-[44px] shrink-0 items-center gap-1.5 text-sm font-semibold text-lime hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-958" data-mp="3qql3emg7wz1k">
            All solutions
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-959" data-mp="1iqtatk0hrdpp" />
          </Link>
        </div>
        <ul className="mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-5" data-id="element-960" data-mp="1xo3j6khu83h7">
          {SOLUTIONS.filter(solution => solution.id !== current).map(solution => <li key={solution.id} data-id="element-961" data-mp="14z4wrb6omf63">
              <Link to={solutionPath(solution.id)} onClick={() => trackEvent('solution_card_click', {
            solution: solution.id,
            placement: `solution_${current}_other`
          })} className="group flex h-full flex-col rounded-xl border border-hairline bg-panel p-4 transition-[border-color,box-shadow] hover:border-[#D8D4EA] hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-962" data-mp="150g2vhnlnz0d">
                <span className="font-mono text-xs font-medium uppercase tracking-[0.14em] text-lime" data-id="element-963" data-mp="hb56ecda8qs1">{solution.label}</span>
                <span className="mt-1.5 text-sm font-semibold text-text-primary" data-id="element-964" data-mp="16xzijb5w11f8">{solution.descriptor}</span>
                <ArrowRightIcon className="mt-auto h-4 w-4 pt-0 text-lime transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-965" data-mp="1ay9owoxldtum" />
              </Link>
            </li>)}
        </ul>
      </div>
    </section>;
}